import { Pipe, PipeTransform, LOCALE_ID, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'utcToDate'
})
export class UtcToDatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(value: string): string {
    const date = new Date(value);
    const datePipe = new DatePipe(this.locale);
    return datePipe.transform(date, 'EEE, MMM d, yyyy');
  }

}
